type IconProps = {
  className?: string;
};

export const ChatBubbleIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={1.8}
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'>
    <path d='M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.8A8 8 0 1 1 21 12Z' />
    <path d='M8.5 12h.01M12 12h.01M15.5 12h.01' strokeWidth={2.6} />
  </svg>
);

export const CloseChatIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    aria-hidden='true'>
    <path d='M6 6l12 12M18 6L6 18' />
  </svg>
);
